import { createStore } from 'vuex';

const store = createStore({
    state: {
        bigLoaderOpened: false,
        bigLoaderText: ''
    },
    mutations: {
        openBigLoader(state, text) {
            if (typeof text != 'undefined') {
                state.bigLoaderText = text;
            }
            state.bigLoaderOpened = true;
        },
        closeBigLoader(state) {
            state.bigLoaderOpened = false;
        }
    },
    getters: {
        getBigLoaderOpened: state => {
            return state.bigLoaderOpened;
        },
        getBigLoaderText: state => {
            return state.bigLoaderText;
        }
    }
});

export default store;